import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'

/**
 * Small amber "Beta" chip shown next to the FlowRent wordmark across the app
 * shell. This is the in-app public-beta signal — App Store-safe (guideline 2.2
 * governs the store icon/listing, not in-app UI) and uniform across platforms,
 * which matters because the iOS launcher icon is intentionally badge-free.
 *
 * GA cleanup: remove this component and its usages (Sidebar, LoginPage,
 * Forgot/ResetPasswordPage, OnboardingLayout).
 */
export function BetaTag({ className = '' }: { className?: string }) {
  const { t } = useTranslation('common')
  return (
    <Badge
      size="xs"
      className={`!bg-warning !text-warning-content !border-transparent font-bold uppercase tracking-wide ${className}`}
    >
      {t('beta')}
    </Badge>
  )
}
